import { Component, OnInit, Input } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-statistiques',
	templateUrl: './statistiques.component.html',
	styleUrls: ['./statistiques.component.scss']
})
export class StatistiquesComponent implements OnInit {
	// Pie chart options
	gradient = true; /// fill elements with a gradient instead of a solid color
	showXAxis = true;
	showYAxis = true;

	@Input() globalStats: any;
	@Input() lpcStats: any;
	@Input() lsfStats: any;
	@Input() pdnStats: any;
	@Input() unassignedStats: any;
	@Input() oralStats: any;
	@Input() stats: any; // TODO: comprendre ce que c'est et pourquoi c'est utilser
	@Input() statsEmployee: any; // TODO: idem, trop de stats => à refaire au propre

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(private facade: FacadeService) {}

	ngOnInit(): void {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}
}
